// The code every AI-quota refusal carries (backend `metering/quota-exhausted.exception.ts`).
export const AI_QUOTA_EXHAUSTED_CODE = 'AI_QUOTA_EXHAUSTED';

// Root of the billing read-out cache. Lives here rather than in the service so the generic mutation
// layer can invalidate it on a refusal without importing a service.
export const BILLING_USAGE_QUERY_BASE = 'BILLING_USAGE';
